import { billingDataForGiftsEnabled } from 'reactApp/appHelpers/featuresHelpers/features/billingDataEndpoint';
import { getBillingDataRequest, updateBillingDataRequest } from 'reactApp/modules/billingData/billingData.module';
import { BillingDataSentGiftsSelectors } from 'reactApp/modules/billingData/billingData.sentGifts.selectors';

import { loadPurchasedGiftsAction, updatePurchasedGiftsAction } from './purchasedGifts.actions';
import {
    getGiftByCode,
    getLastPurchasedGiftById,
    getNonActivatedGifts,
    getNonActivatedNonExpiredGifts,
    sortPurchasedGiftsByCreatedDate,
} from './purchasedGifts.selectors';

export const loadPurchasedGiftsActionFallback = () => (dispatch) => {
    if (billingDataForGiftsEnabled) {
        dispatch(getBillingDataRequest({ radar: 'giftsent' }));
    } else {
        dispatch(loadPurchasedGiftsAction());
    }
};

export const updatePurchasedGiftsActionFallback =
    ({ count }: { count?: number } = {}) =>
    (dispatch) => {
        if (billingDataForGiftsEnabled) {
            dispatch(updateBillingDataRequest({ showSnackbar: false, count, radar: 'giftsent', trackFields: ['gift_sent'] }));
        } else {
            dispatch(updatePurchasedGiftsAction({ count }));
        }
    };

export const GiftPurchasedSelectors = {
    getGiftByCode: !billingDataForGiftsEnabled ? getGiftByCode : BillingDataSentGiftsSelectors.getGiftByKey,
    getLastPurchasedGiftById: !billingDataForGiftsEnabled
        ? getLastPurchasedGiftById
        : BillingDataSentGiftsSelectors.getLastPurchasedGiftById,
    getNonActivatedGifts: !billingDataForGiftsEnabled ? getNonActivatedGifts : BillingDataSentGiftsSelectors.getNonActivatedGifts,
    getNonActivatedNonExpiredGifts: !billingDataForGiftsEnabled
        ? getNonActivatedNonExpiredGifts
        : BillingDataSentGiftsSelectors.getNonActivatedNonExpiredGifts,
    sortPurchasedGiftsByCreatedDate: !billingDataForGiftsEnabled
        ? sortPurchasedGiftsByCreatedDate
        : BillingDataSentGiftsSelectors.sortPurchasedGiftsByCreatedDate,
} as const;
